export const moduleName = 'battle'

export const SET_STAGE = `${moduleName}/SET_STAGE`
export const SET_SELECTED_BET = `${moduleName}/SET_SELECTED_BET`
export const SET_RESULT = `${moduleName}/SET_RESULT`
export const CLEAR_BATTLE = `${moduleName}/CLEAR_BATTLE`
export const SET_BATTLE_PLAYERS = `${moduleName}/SET_BATTLE_PLAYERS`
